<script>
import { Scatter } from "vue-chartjs";
import Chart from "chart.js";
import * as ChartjsAnnotation from "chartjs-plugin-annotation";

Chart.plugins.register(ChartjsAnnotation);

export default {
  name: "ScatterplotSterblichkeit",
  extends: Scatter,
  props: [
    "bezirk",
    "color",
    "alle",
    "value",
    "formatter",
    "xaxis",
    "other_values",
    "other_values_instructions",
    "times_avg"
  ],
  mounted() {
    this.renderChart(this.chartjs_data, this.chartjs_options);

    var originalGetElementAtEvent = this.$options._chart.getElementAtEvent;
    this.$options._chart.getElementAtEvent = function() {
      return originalGetElementAtEvent
        .apply(this, arguments)
        .filter(function(e) {
          return e._datasetIndex == 0;
        });
    };
  },
  watch: {
    bezirk() {
      this.$nextTick(() => {
        this.$options._chart.config.data = this.chartjs_data;
        this.$options._chart.config.options = this.chartjs_options;
        this.$options._chart.update();
      });
    },
    value() {
      this.$nextTick(() => {
        this.$options._chart.config.data = this.chartjs_data;
        this.$options._chart.config.options = this.chartjs_options;
        this.$options._chart.update();
      });
    },
    xaxis() {
      this.$nextTick(() => {
        this.$options._chart.destroy();
        //            this.$options._chart.config.data.datasets = this.chartjs_data.datasets;
        //            this.$options._chart.config.options = this.chartjs_options;
        //            this.$options._chart.update();
        this.renderChart(this.chartjs_data, this.chartjs_options);
      });
    }
  },
  computed: {
    chartjs_data() {
      const cur = {
        label: this.bezirk[0].Bundesland,
        data: this.bezirk.map(d => ({
          x: this.xaxis == "day" ? d.week : d["bestätigte Fälle"],
          y: d[this.value],
          label: d[this.value],
          original_data: d
        })),
        showLine: true,
        fill: false,
        borderColor: this.color,
        pointRadius: 0
      };
      return {
        datasets: [cur]
          .concat(
            this.other_values.map((v, i) => ({
              label: v,
              data: this.bezirk
                .filter(d => !isNaN(d[v]))
                .map(d => ({
                  x: this.xaxis == "day" ? d.week : d["bestätigte Fälle"],
                  y: d[v],
                  original_data: d
                })),
              showLine: true,
              fill: i == 1 ? "1" : false,
              borderColor: "rgba(200, 200, 200, 0.5)",
              borderWidth: 1,
              pointRadius: 0
            }))
          )
          .concat(
            this.alle.length == 0
              ? []
              : [
                  {
                    label: this.alle[0].Bundesland,
                    data: this.alle.map(d => ({
                      x: this.xaxis == "day" ? d.week : d["bestätigte Fälle"],
                      y: d[this.value],
                      label: d[this.value],
                      original_data: d
                    })),
                    showLine: true,
                    fill: false,
                    borderColor: "#8e8e8e",
                    borderWidth: 1.5,
                    pointRadius: 0
                  }
                ]
          )
      };
    },
    chartjs_options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 1,

        annotation: { annotations: this.chartjs_annotations },
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        scales: {
          xAxes: [
            {
              id: "xTimeScale",
              type: "linear",
              scaleLabel: {
                display: false
              },
              ticks: {
                min: 2,
                stepSize: 5,
                source: "data",
                autoskip: false
              }
            }
          ],
          yAxes: [
            {
              type: "linear",
              ticks: {
                min: 0,
                max: Math.round(this.average_usual_day * this.times_avg),
                maxTicksLimit: 5,
                callback: d => {
                  if (d % 100 == 0) {
                    return this.$fmt(",d")(d);
                  }
                }
              }
            }
          ]
        },
        hover: {
          mode: "nearest"
        },
        tooltips: {
          mode: "index",
          intersect: false,
          filter: tooltipItem => tooltipItem.datasetIndex == 0,
          callbacks: {
            label: tooltipItem => {
              var b = this.chartjs_data.datasets[tooltipItem.datasetIndex].data[
                tooltipItem.index
              ].original_data;
              return [
                `Woche ${tooltipItem.xLabel}: ${this.$fmt(",d")(
                  b[this.value]
                )}`,
                `Üblich: (${this.$fmt(",d")(b["Minimalwert"])} – ${this.$fmt(
                  ",d"
                )(b["Maximalwert"])})`
              ];
            }
          },
          displayColors: false
        },
        layout: {
          padding: {
            left: 0,
            top: 0,
            right: 0,
            bottom: 5
          }
        }
      };
    },
    average_usual_day() {
      var tmp = this.bezirk.map(d => {
        return this.other_values.map(k => d[k]).reduce((a, b) => a + b, 0) / 2;
      });
      return tmp.reduce((a, b) => a + b, 0) / tmp.length;
    },
    nan_days() {
      return this.bezirk.filter(
        d => d.week > "2020-04-01" && isNaN(d[this.value])
      );
    },
    chartjs_annotations() {
      return [];
    }
  }
};
</script>
